import React from 'react';
import { Globe2, Lock } from 'lucide-react';

// Visibilité d'un point à aborder : privé (seule la personne qui l'a noté le voit) ou public (toute l'équipe Innowide,
// et Muse). Par défaut public pour une réunion avec des personnes extérieures, privé pour une réunion interne.
export const defaultVisibility = (external) => (external === false ? 'private' : 'public');

export const visibilityLabel = (visibility) => (visibility === 'private'
  ? 'Privé : visible de toi seul. Clique pour le rendre public (toute l’équipe Innowide le verra).'
  : 'Public : visible de toute l’équipe Innowide. Clique pour le garder pour toi.');

// Bascule d'un point existant (seulement pour la personne qui l'a noté) ; les points privés gardent leur cadenas.
export const PointVisibility = ({ point, mine, onChange }) => {
  const isPrivate = point.visibility === 'private';
  if (!mine) return null;
  return (
    <button
      type="button"
      title={visibilityLabel(point.visibility)}
      onClick={() => onChange(isPrivate ? 'public' : 'private')}
      className={`mt-0.5 shrink-0 rounded p-0.5 ${isPrivate
        ? 'text-amber-600 hover:bg-amber-50'
        : 'text-slate-300 opacity-0 hover:bg-slate-100 hover:text-slate-500 group-hover:opacity-100'}`}
    >
      {isPrivate ? <Lock size={12} /> : <Globe2 size={12} />}
    </button>
  );
};

// Choix pour le prochain point ajouté.
export const NewPointVisibility = ({ value, onChange }) => (
  <button
    type="button"
    title={visibilityLabel(value)}
    onClick={() => onChange(value === 'private' ? 'public' : 'private')}
    className={`flex shrink-0 items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium ${value === 'private'
      ? 'bg-amber-50 text-amber-700 hover:bg-amber-100' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
  >
    {value === 'private' ? <Lock size={11} /> : <Globe2 size={11} />}
    {value === 'private' ? 'Privé' : 'Public'}
  </button>
);
